import React, { useRef, useState } from 'react';
import { OutlineButton } from "@shared/ui/atoms/buttons/OutlineButton";
import { saveWeeklyNotes } from '@features/whereabouts/services/WeekNotesService';
import { Moment } from "moment";
import styled from "styled-components";
import { WithSingleUserWeekNotes } from "./WithSingleUserWeekNotes";

export function SetWeeklyNote(props: Props) {
  const {userId, date} = props;
  const [disabled, setDisabled] = useState(false);
  const textRef = useRef<any>(null);

  const weekNote = WithSingleUserWeekNotes(userId, date);

  const save = async () => {
    try {
      setDisabled(true);
      await saveWeeklyNotes(userId, date, textRef.current.value);
      props.done();
    } finally {
      setDisabled(false);
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey && !disabled && !weekNote.loading) {
      e.preventDefault();
      save();
    }
  };

  const cancel = () => {
    props.done();
  }

  return (
    <EditContainer>
      <TextArea ref={textRef} defaultValue={(weekNote?.notes?.note ?? '').replaceAll('', '')} disabled={disabled || weekNote.loading} onKeyDown={handleKeyDown} />

      <ButtonContainer>
        <OutlineButton text={'button.cancel'} click={() => cancel()}
                       style={{marginRight: '2%'}}
                       disabled={disabled || weekNote.loading} />
        <OutlineButton text={'button.done'} click={() => save()}
                       style={{marginLeft: '2%'}}
                       disabled={disabled || weekNote.loading} />
      </ButtonContainer>
    </EditContainer>
  )
}

interface Props {
  done: () => any;
  userId: string;
  date: Moment;
}

const EditContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 400px;
`

const TextArea = styled.textarea`
  width: 100%;
  flex: 1;
  min-height: 150px;
  margin-bottom: 16px;
  padding: 4px 8px;
  font-size: 16px;
  font-family: "soleil", sans-serif;
  white-space: pre-wrap;
`

const ButtonContainer = styled.div`
  display: flex;
  margin-top: auto;
`
